// extracted by mini-css-extract-plugin
module.exports = {"md":"bonus-amount_md_4eYmg","ios":"bonus-amount_ios_2_O2Y","icon":"bonus-amount_icon_1TckS","smallText":"bonus-amount_smallText_1-4zy"};